// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

    production: true,


    apiUrl: 'https://qual-coudpouce.bizzdev.net/api',

    apiDomain: 'qual-coudpouce.bizzdev.net',
    identityApiUrl: 'https://qual-coudpouce.bizzdev.net/identity/',
    whiteListedUrl: 'https://qual-coudpouce.bizzdev.net/api',
    socialBlackListedUrl: 'https://qual-coudpouce.bizzdev.net/api/user/socials/login',
    blacklistedUrl: 'https://qual-coudpouce.bizzdev.net/identity/',


    tokenKey: 'bizz-coudpouce-token-admin',
    tokenExpKey: 'bizz-coudpouce-token-exp-admin',
    rfTokenKey: 'bizz-coudpouce-rf-token-admin',


    appName: 'Coud\' Pouce',
    version: '0.0.1',

    localTranslations: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
